module.exports = __webpack_public_path__ + "img/Yogurt-Nan-1200x790.f78cb0be.jpg";